import { ORGANISATIONS_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(ORGANISATIONS_ENDPOINT);
export default instance;
